import { z } from 'zod';
import { AdditionalPropertiesIdSchema } from '../enums/additional-properties-schema-id.ts';
import { AbstractAdditionalProperties } from './abstract-additional-properties.ts';

export const ManualServicePropertiesSchemaV1 = z.object({
    ...AbstractAdditionalProperties.shape,
    schemaId: AdditionalPropertiesIdSchema.extract(['MANUAL_SERVICE_V1']),
});
export type ManualServicePropertiesV1 = z.infer<typeof ManualServicePropertiesSchemaV1>;
